<template>
  <div class="center">
		<h2 >Verify your Email</h2>
    
 <br />
To proceed with the creation of your account, simply give that button below a click to verify your email: {{ email }}
<br />
<br />

<v-btn  color="primary" :disabled="confirm" @click="submit">confirm email</v-btn>

<div v-if="confirm">
	<br />
	Thank you! Please wait for an email confirming your account activation.
</div>
	
</div>
</template>
<script>
import axiosInstances from '../server/axiosInstances'
export default {
	data: () => ({
    email: '',
		confirm: false
	}),
	methods: {
		async submit() {
			console.log(this.email)
			let res = await axiosInstances.loginServer.post("/auth/dmz",
                        {"email": this.email, "action": "email_verification", "verified": "yes"})
			console.log(res)
			this.confirm = true
		}
	},
	mounted() {
		this.email = this.$route.query.email
	}
}
</script>


<style scoped    >
.center {
  margin: auto;
  width: 50%;
  padding: 10px;
}
</style>